<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="200"
      size="mini"
      resizable
      border
      ref="contrinerTable"
      :mouse-config="{ selected: true }"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        activeMethod: activeCellMethod,
      }"
      :edit-rules="validRules"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          type: 'seq',
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
        },
        {
          title: this.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
          field: 'editContainerNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_contractNo') || '合同号',
          field: 'contractNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_importerPo') || '进口商PO',
          field: 'importerPo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_bookingNo') || '订舱单号',
          field: 'bookingNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_bookingNo') || '请输入订舱单号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_customsNo') || '关单号',
          field: 'customsNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_customsNo') || '请输入关单号',
              clearable: true,
            },
          },
        },
      ],
      validRules: {
        bookingNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingNo') || '请输入订舱单号',
          },
        ],
        customsNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsNo') || '请输入关单号',
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.contrinerTable.getTableData() || {}
      return fullData
    },
    async validate() {
      const result = await this.$refs.contrinerTable.validate(true)
      return !result
    },
    activeCellMethod() {
      return !this.disabled
    },
    editClosed() {
      const data = this.getTableData()
      if (!data) return

      const bookingNos = data.map((item) => item.bookingNo)
      const customsNos = data.map((item) => item.customsNo)
      const params = {
        bookingNo: bookingNos.filter(Boolean).join(),
        customsNo: customsNos.filter(Boolean).join(),
      }

      if (this.disabled) return
      this.$emit('editClosed', params)
    },
  },
}
</script>
